import { Component, Input } from '@angular/core';

export type StatusBadgeTipo = 'bloqueado' | 'agendado' | 'disponivel' | 'em_andamento' | 'concluido' | 'expirando';

@Component({
    selector: 'status-badge',
    templateUrl: './status-badge.component.html',
    styleUrls: ['./status-badge.component.scss']
})
export class StatusBadgeComponent {
    @Input() tipo!: StatusBadgeTipo;
    @Input() label!: string;
    @Input() detalhe?: string;
    @Input() tooltip?: string;
}
